import { Stack, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../../context";
import InfoTerms from "./InfoTerms";

// ----------------------------------------------------------------------

type Props = {
	title: string;
};

export const InfoTitle = ({ title }: Props) => {
	const { id, theme } = useContext(Context);
	const queryClient = useQueryClient();
	const details = queryClient.getQueryData<{ name: string }>(["link", "details", id]);

	const { translate } = useLocales();

	return (
		<Stack>
			<Typography variant='subtitle1' fontSize={18} color={theme?.colors.primaryText}>
				{translate(title)}
			</Typography>
			<Typography variant='h3' textTransform={"capitalize"} color={theme?.colors.primaryText}>
				{details?.name}
			</Typography>
			<InfoTerms />
		</Stack>
	);
};

export default InfoTitle;
